import type { HttpClient } from '@remodeling/base';
import {
  GetGoodsCategoryRequest,
  GetGoodsCategoryResponse,
  GetHamburgerCategoryResponse,
} from '../../model/dto/category';

export class GetGoodsCategoryGateway {
  constructor(readonly httpClient: HttpClient) {}

  async exec(req: GetGoodsCategoryRequest) {
    return await this.httpClient.request<GetGoodsCategoryResponse>({
      method: 'GET',
      url: `${process.env.NEXT_PUBLIC_BASE_API_URL}${process.env.NEXT_PUBLIC_GW_PATH_PREFIX}/content-info-service/api/v1/categories/cascade`,
      body: req,
    });
  }
}

export class GetHamburgerCategoryGateway {
  constructor(readonly httpClient: HttpClient) {}

  async exec() {
    return await this.httpClient.request<GetHamburgerCategoryResponse>({
      method: 'GET',
      url: `${process.env.NEXT_PUBLIC_BASE_API_URL}${process.env.NEXT_PUBLIC_GW_PATH_PREFIX}/content-service/api/v1/categories/hs-mall/navigation-list-all`,
      body: {
        typeValue: 'MOBILE',
      },
    });
  }
}
